import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaTwitter,
  FaFacebookF,
  FaYoutube,
  FaGoogle,
  FaBars,
  FaTimes,
  
} from "react-icons/fa";
import { FaPhoneVolume } from "react-icons/fa6";
import logo from "../../Images/logo.gif"

function Header() {
  const navigate = useNavigate()
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
     
      <div className="fixed top-0 left-0 w-full flex flex-col sm:flex-row sm:justify-between gap-2 sm:gap-6 px-4 sm:px-6 py-6 bg-black text-white text-xs sm:text-sm z-20">
        <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-6">
          
          <span className="flex items-center gap-2">
            <FaEnvelope /> book@pickquickcabs.com
          </span>
        </div>
        <div className="flex  gap-4  md:justify-end">
          <FaTwitter />
          <a
          href="https://www.facebook.com/pickquickcabs/"
              target="blank"
          >
            <FaFacebookF />

          </a>
          
          <FaYoutube />
          <FaGoogle />
        </div>
      </div>


     <div className="bg-yellow-400 fixed top-0 left-0 right-0 flex items-center gap-16 px-4 sm:px-8 py-4 z-30 mt-16">

  
  <div className="flex items-center gap-3 cursor-pointer" onClick={() => navigate("/")}>
    <img
      src={logo}
      alt="logo"
      className="h-10 sm:h-14 object-contain"
    />
    <span className="font-extrabold text-xl sm:text-2xl tracking-wide text-black">
      PICK QUICK CABS
    </span>
  </div>

 
  <ul className="hidden lg:flex gap-6 lg:gap-6 font-semibold">
    <li className="text-gray-600 font-bold cursor-pointer hover:text-black" onClick={()=> navigate('/')}>HOME</li>
    <li className="cursor-pointer text-gray-600 font-bold hover:text-black" onClick={()=> navigate('/char-dham-yatra-cab-service')}>CHAR DHAM</li>
    <li className="cursor-pointer text-gray-600 font-bold hover:text-black" onClick={()=> navigate('/our-taxi-service')}>OUR TAXI</li>
    <li className="cursor-pointer text-gray-600 font-bold hover:text-black" onClick={()=> navigate('/book-a-ride')}>BOOK A RIDE</li>
    <li className="cursor-pointer text-gray-600 font-bold hover:text-black" onClick={()=> navigate('/outstation-cab-service-near-me')}>OUT STATION</li>
    <li className="cursor-pointer text-gray-600 font-bold hover:text-black" onClick={()=> navigate('/contact-us')}>CONTACT</li>
  </ul>

 
  <button
    className="lg:hidden text-black text-2xl"
    onClick={() => setMenuOpen(!menuOpen)}
  >
    {menuOpen ? <FaTimes /> : <FaBars />}
  </button>

  
  <div className="hidden md:flex items-center bg-black text-white px-6 py-2 rounded-l-full absolute right-0 top-0 bottom-0">
    <FaPhoneVolume className="text-yellow-400 mr-4 size-10" />
    <div>
      <p className="font-medium text-lg text-yellow-400">8447433852</p>
      <p className="text-[10px] lg:text-xs">PHONE LINE</p>
    </div>
  </div>
</div>


      {menuOpen && (
        <div className="lg:hidden bg-yellow-300 text-black font-semibold flex flex-col gap-4 px-6 py-6 fixed top-32 z-50 left-0 right-0">
          <p onClick={()=> navigate('/')} className="cursor-pointer text-gray-600 font-bold hover:text-black">HOME</p>
          <p onClick={()=> navigate('/char-dham-yatra-cab-service')} className="cursor-pointer text-gray-600 font-bold hover:text-black">CHAR DHAM</p>
          <p onClick={()=> navigate('/our-taxi-service')} className="cursor-pointer text-gray-600 font-bold hover:text-black">OUR TAXI</p>
          <p onClick={()=> navigate('/book-a-ride')} className="cursor-pointer text-gray-600 font-bold hover:text-black">BOOK A RIDE</p>
          <p onClick={()=> navigate('/outstation-cab-service-near-me')} className="cursor-pointer text-gray-600 font-bold hover:text-black">OUT STATION</p>
          <p onClick={()=> navigate('/blog')}className="cursor-pointer text-gray-600 font-bold hover:text-black">BLOG</p>
          <p onClick={()=> navigate('/contact-us')} className="cursor-pointer text-gray-600 font-bold hover:text-black">CONTACT</p>


          <div className="flex items-center gap-2 bg-black text-yellow-400 px-4 py-2 rounded-lg mb-4">
            <FaPhoneAlt className="text-yellow-400" />
            <span className="text-sm md:text-base">84 47 43 38 52</span>
          </div>
        </div>
      )}
    </>
  );
}

export default Header;
